// FormQuizTitle

const getQuizTitle = (state, action) => {

  const quizTitle = action.payload;

  // const reg = /header/

  const checkVaules = state.values.map(el => el.filter(i => i === "").length > 0).filter(ii => ii === true).length
    ? false
    : true;

  const checkHeaders = state.headers.filter((el) => el === "").length
    ? false
    : true;

  const checkQuizTitle = quizTitle === ""
    ? false
    : true;

  if (!checkQuizTitle || !checkHeaders || !checkVaules) {
    return {
      ...state,
      quizStatus: "initial",
      quizTitle,
      alertStatus: null,
      video: false,
      errorMessage: false,
      checkVaules,
      checkHeaders,
      checkQuizTitle
    };
  } else {
    return {
      ...state,
      quizStatus: "initial",
      quizTitle,
      alertStatus: "changes made",
      video: false,
      errorMessage: false,
      checkVaules,
      checkHeaders,
      checkQuizTitle
    };
  }
}

export default getQuizTitle